import React from 'react';
import { useTheme } from '../context/ThemeContext';

const ThemeToggle = () => {
  const { theme, toggleTheme } = useTheme();

  return (
    <button
      onClick={toggleTheme}
      className="p-0 transition-transform duration-200 hover:scale-110 cursor-pointer"
      title={`Switch to ${theme === 'dark' ? 'light' : 'dark'} mode`}
      style={{
        background: 'none',
        border: 'none',
        boxShadow: 'none',
        lineHeight: 0
      }}
    >
      <img
        src={theme === 'dark' ? '/sun.png' : '/moon.png'}
        alt={theme === 'dark' ? 'Light mode' : 'Dark mode'}
        className="w-5 h-5"
        style={{
          filter: theme === 'dark' ? 'brightness(0) invert(1)' : 'none'
        }}
      />
    </button>
  );
};

export default ThemeToggle;